import { useReducer } from "react";
import {
  Configuration,
  Dimensions,
  Parapet,
  Roof,
  Gutter,
  Wall,
  OptionsMaterial,
} from "src/types/configuration";

type State = Configuration;
type Action =
  | { type: "SET_CONFIGURATION"; payload: Configuration }
  | { type: "SET_ROOF_TYPE"; payload: string }
  | { type: "SET_DIMENSIONS"; payload: Dimensions }
  | { type: "SET_PARAPET"; payload: Parapet }
  | { type: "SET_ROOF"; payload: Roof }
  | { type: "SET_GUTTER"; payload: Gutter }
  | { type: "SET_WALLS"; payload: Wall[] }
  | { type: "SET_STORAGES"; payload: { left: boolean; right: boolean; leftLuifelEnabled?: boolean; rightLuifelEnabled?: boolean } }
  | { type: "SET_OPTION_MATERIAL"; payload: OptionsMaterial };

const initialConfiguration: Configuration = {
  roofType: "platdak",
  dimensions: {
    width: 5000,
    depth: 3000,
    height: 2200,
    angle: 30,
    overhangFront: 150,
    overhangBack: 0,
    overhangLeft: 0,
    overhangRight: 0,
    leftStorageWidth: 3000,
    rightStorageWidth: 3000,
  },
  parapet: { enabled: false, height: 50, type: "metselwerk" },
  roof: {
    type: "empty",
    epdmGlue: false,
    walls: {
      left: {
        name: "empty",
        rotate: false,
        innerWallEnabled: false,
        innerWallType: "naturel",
        outerWallType: "naturel",
        window: "wit",
      },
      right: {
        name: "empty",
        rotate: false,
        innerWallEnabled: false,
        innerWallType: "naturel",
        outerWallType: "naturel",
        window: "wit",
      },
    },
  },
  gutter: { enabled: false, type: "zink" },
  walls: [],
  storages: { left: false, right: false, leftLuifelEnabled: false, rightLuifelEnabled: false },
  optionsMaterial: {
    liter_beits_zwart: 0,
    liter_beits_wit: 0,
    liter_beits_gray: 0,
    liter_beits_douglas: 0,
    poer: "empty",
    poerQuantity: 0,
    daktrim_blank: true,
    daktrim_zwart: false,
    montage: false,
    hemelwaterafvoer_pvc: false,
    betonband_antraciet: 0,
  },
  params: {
    platdakColumn: 150,
    kapschuurColumn: 150,
    kapschuurRoofThickness: 390,
    kapschuurOverhang: 1391,
    kapschuurOverhangLength: 1607,
    kapschuurOverhangSmallAngle: 30,
    kapschuurOverhangBigAngle: 20,
    kapschuurBigHeight: 3000,
    kapschuurSmallHeight: 2060,
    kapschuurNokLabelMm: 3090,
  },
};

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "SET_CONFIGURATION":
      return { ...action.payload };
    case "SET_ROOF_TYPE":
      return { ...state, roofType: action.payload };
    case "SET_DIMENSIONS":
      return { ...state, dimensions: action.payload };
    case "SET_PARAPET":
      return { ...state, parapet: action.payload };
    case "SET_ROOF":
      return { ...state, roof: action.payload };
    case "SET_GUTTER":
      return { ...state, gutter: action.payload };
    case "SET_WALLS":
      return { ...state, walls: action.payload };
    case "SET_STORAGES":
      return { ...state, storages: action.payload };
    case "SET_OPTION_MATERIAL":
      return { ...state, optionsMaterial: action.payload };
    default:
      return state;
  }
}

const useConfigurationState = () => {
  const [state, dispatch] = useReducer(reducer, initialConfiguration);

  return { state, dispatch };
};

export default useConfigurationState;
